import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const About = () => {
  const values = [
    {
      title: "Expert-Led Training",
      description: "Learn from industry professionals with real-world experience in DevOps and Full-Stack development.",
      icon: "🎓"
    },
    {
      title: "Hands-On Projects",
      description: "Build real projects that showcase your skills and prepare you for professional environments.",
      icon: "💼"
    },
    {
      title: "Career Support",
      description: "Get personalized job assistance, interview preparation, and resume building guidance.",
      icon: "🚀"
    },
    {
      title: "Modern Technologies",
      description: "Stay current with the latest tools and frameworks used in today's tech industry.",
      icon: "⚡"
    }
  ];

  const stats = [
    { number: "500+", label: "Students Trained" },
    { number: "85%", label: "Job Placement Rate" },
    { number: "100+", label: "Projects Completed" }
  ];

  return (
    <Container className="page-shell about-page my-5">
      <Row className="mb-5 page-header">
        <Col>
          <span className="eyebrow dark">About us</span>
          <h1 className="text-center mb-3 fw-bold">About SPARKLOGIC</h1>
          <p className="page-subtitle text-center mx-auto">
            SPARKLOGIC is a leading technology training institute dedicated to empowering
            individuals with cutting-edge skills in DevOps, Cloud Automation, Full-Stack
            MERN development, and Automation Testing. We bridge the gap between learning
            and career success.
          </p>
        </Col>
      </Row>

      {/* Mission Section */}
      <Row className="mb-5">
        <Col md={6} className="mb-4 mb-md-0">
          <Card className="h-100 info-card border-0">
            <Card.Body className="p-4">
              <h3 className="mb-3">Our Mission</h3>
              <p>
                To provide comprehensive, industry-relevant training that transforms
                aspiring professionals into skilled DevOps engineers, Full-Stack
                developers, and Automation Testing specialists. We believe in practical,
                hands-on learning that prepares you for real-world challenges and career
                opportunities.
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="h-100 info-card border-0">
            <Card.Body className="p-4">
              <h3 className="mb-3">Our Vision</h3>
              <p>
                To become the premier destination for technology education, recognized for 
                producing highly skilled professionals who excel in their careers. We aim 
                to create a community of learners who drive innovation and excellence in 
                the tech industry.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Values Section */}
      <Row className="mb-5">
        <Col>
          <h2 className="text-center mb-4">Why Choose SPARKLOGIC?</h2>
          <Row className="g-4">
            {values.map((value, index) => (
              <Col key={index} xs={12} sm={6} md={3}>
                <Card className="h-100 info-card border-0 text-center">
                  <Card.Body className="p-4">
                    <div className="mb-3" style={{ fontSize: "3rem" }}>
                      {value.icon}
                    </div>
                    <Card.Title>{value.title}</Card.Title>
                    <Card.Text className="text-muted">
                      {value.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>

      {/* Stats Section */}
      <Row className="mb-5">
        <Col>
          <h2 className="text-center mb-4">Our Impact</h2>
          <Row className="g-4 justify-content-center">
            {stats.map((stat, index) => (
              <Col key={index} xs={12} sm={6} md={3}>
                <Card className="h-100 metric-card border-0 text-center">
                  <Card.Body className="p-4">
                    <h2 className="fw-bold text-primary mb-2">{stat.number}</h2>
                    <p className="mb-0 text-muted">{stat.label}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>

      {/* What We Offer Section */}
      <Row className="mb-5">
        <Col>
          <h2 className="text-center mb-4">What We Offer</h2>
          <Row>
            <Col md={4} className="mb-4">
              <Card className="h-100 info-card border-0">
                <Card.Body className="p-4">
                  <h4 className="mb-3">DevOps & Cloud Automation</h4>
                  <ul className="feature-list list-unstyled">
                    <li className="mb-2">✓ CI/CD Pipeline Development</li>
                    <li className="mb-2">✓ Containerization with Docker</li>
                    <li className="mb-2">✓ Kubernetes Orchestration</li>
                    <li className="mb-2">✓ Cloud Infrastructure (AWS)</li>
                    <li className="mb-2">✓ Infrastructure as Code (Terraform)</li>
                    <li className="mb-2">✓ JFrog Artifactory</li>
                    <li className="mb-2">✓ SonarQube Code Quality</li>
                    <li className="mb-2">✓ Argo CD</li>
                    <li className="mb-2">✓ Monitoring & Alerting</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="mb-4">
              <Card className="h-100 info-card border-0">
                <Card.Body className="p-4">
                  <h4 className="mb-3">Full-Stack MERN Development</h4>
                  <ul className="feature-list list-unstyled">
                    <li className="mb-2">✓ MongoDB Database Design</li>
                    <li className="mb-2">✓ Express.js Backend Development</li>
                    <li className="mb-2">✓ React Frontend Development</li>
                    <li className="mb-2">✓ Node.js Server-Side Programming</li>
                    <li className="mb-2">✓ RESTful API Development</li>
                    <li className="mb-2">✓ Modern UI/UX Design</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="mb-4">
              <Card className="h-100 info-card border-0">
                <Card.Body className="p-4">
                  <h4 className="mb-3">Job Assistance Program</h4>
                  <ul className="feature-list list-unstyled">
                    <li className="mb-2">✓ Resume Building & Optimization</li>
                    <li className="mb-2">✓ Interview Preparation</li>
                    <li className="mb-2">✓ Portfolio Development</li>
                    <li className="mb-2">✓ Mock Interviews</li>
                    <li className="mb-2">✓ Career Guidance</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col>
          <Card className="info-card border-0 overflow-hidden">
            <Card.Body className="p-4 p-md-5">
              <Row className="align-items-center g-4">
                <Col lg={4} className="text-center">
                  <div className="rounded-circle bg-primary bg-opacity-10 d-inline-flex align-items-center justify-content-center" style={{ width: "110px", height: "110px", fontSize: "3rem" }}>
                    ☁️
                  </div>
                </Col>
                <Col lg={8}>
                  <span className="eyebrow dark">Specialized track</span>
                  <h3 className="mt-2 mb-3">DevOps & Cloud Automation</h3>
                  <p className="mb-3">
                    Build the infrastructure and deployment workflows that power modern
                    software teams. This program equips you to automate environments,
                    streamline releases, and manage scalable cloud systems with confidence.
                  </p>
                  <ul className="feature-list list-unstyled mb-0">
                    <li className="mb-2">✓ CI/CD pipeline design and deployment automation</li>
                    <li className="mb-2">✓ Docker, Kubernetes, and container orchestration</li>
                    <li className="mb-2">✓ Cloud infrastructure management on AWS and modern platforms</li>
                    <li className="mb-2">✓ Terraform, monitoring, and production-ready DevOps workflows</li>
                  </ul>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Call to Action */}
      <Row>
        <Col>
          <Card className="cta-panel border-0 text-white">
            <Card.Body className="p-5 text-center">
              <h3 className="mb-3">Ready to Start Your Journey?</h3>
              <p className="lead mb-4" style={{ color: "rgba(255,255,255,0.9)" }}>
                Join SPARKLOGIC today and take the first step towards a successful career 
                in technology. Our comprehensive programs are designed to help you achieve 
                your professional goals.
              </p>
              <a 
                href="/contact" 
                className="btn btn-light btn-lg"
                style={{ textDecoration: "none" }}
              >
                Get Started
              </a>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default About;

